var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4051_265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.682617,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4051_265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.56722 15.0577H10.5672V8.9423H9.56722V15.0577ZM12.798 15.0577L17.3942 12L12.798 8.9423V15.0577ZM12.686 21C11.4414 21 10.2713 20.7638 9.17572 20.2915C8.0801 19.8192 7.12706 19.1782 6.31659 18.3685C5.50614 17.5588 4.86453 16.6066 4.39177 15.512C3.919 14.4174 3.68262 13.2479 3.68262 12.0034C3.68262 10.7588 3.91878 9.58872 4.39109 8.4931C4.86343 7.39748 5.50444 6.44444 6.31414 5.63398C7.12384 4.82353 8.07598 4.18192 9.17057 3.70915C10.2652 3.23638 11.4347 3 12.6793 3C13.9238 3 15.0939 3.23616 16.1895 3.70847C17.2851 4.18081 18.2382 4.82182 19.0486 5.63152C19.8591 6.44122 20.5007 7.39337 20.9735 8.48795C21.4462 9.58255 21.6826 10.7521 21.6826 11.9966C21.6826 13.2412 21.4465 14.4113 20.9741 15.5069C20.5018 16.6025 19.8608 17.5556 19.0511 18.366C18.2414 19.1765 17.2893 19.8181 16.1947 20.2909C15.1001 20.7636 13.9305 21 12.686 21ZM12.6826 20C14.916 20 16.8076 19.225 18.3576 17.675C19.9076 16.125 20.6826 14.2333 20.6826 12C20.6826 9.76667 19.9076 7.875 18.3576 6.325C16.8076 4.775 14.916 4 12.6826 4C10.4493 4 8.55762 4.775 7.00762 6.325C5.45762 7.875 4.68262 9.76667 4.68262 12C4.68262 14.2333 5.45762 16.125 7.00762 17.675C8.55762 19.225 10.4493 20 12.6826 20Z",
    fill: "#15B79E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.2e1d3068938c44a830958a44caea0cc6.svg";
export { ForwardRef as ReactComponent };